import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedVideos from '@/pages/home/components/FeaturedVideos';
import HotVideos from '@/pages/home/components/HotVideos';
import LatestArticles from '@/pages/home/components/LatestArticles';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import FAQSection from '@/pages/home/components/FAQSection';

export default function Home() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "精品视频 - 首页",
    "description": "精品视频汇聚海量高清影视、教育、娱乐内容，画质清晰、更新及时、分类精准，让您随时随地享受顶级视觉体验。",
    "url": "https://www.jingpinshipin.com",
  };

  return (
    <>
      <SEOHead
        title="首页"
        description="精品视频汇聚海量高清影视、教育、娱乐内容，画质清晰、更新及时、分类精准，让您随时随地享受顶级视觉体验。立即免费体验精品视频，发现更多优质内容资源。"
        keywords="精品视频,高清视频,优质视频内容,在线视频平台,免费视频,视频资源,热门视频推荐"
        schema={schema}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategorySection />
          <FeaturedVideos />
          <HotVideos />
          <LatestArticles />
          <FeaturesSection />
          <FAQSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}